import { render, staticRenderFns } from "./UserScans.vue?vue&type=template&id=d9fa224e&scoped=true"
import script from "./UserScans.vue?vue&type=script&lang=js"
export * from "./UserScans.vue?vue&type=script&lang=js"
import style0 from "./UserScans.vue?vue&type=style&index=0&id=d9fa224e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fa224e",
  null
  
)

export default component.exports